define('viewModels/widgets/FileSelector',[
    'jquery',
    'lib/knockout',
    'lib/lodash4',
    'services/loggingService',
    'util/errorCallbackFactory',
    'viewModels/ViewModel',
    'services/outbound/fileReaderUtils'
], function ($, ko, _, LOG, errorCallbackFactory, ViewModel, fileReaderUtils) {
    'use strict';

    var FileSelector = ViewModel.extend(function () {
        var self = this;

        self.uploadPlaceholder = ko.i18n.renderString('fileSelector.uploaderPlaceholder');

        var fileToUpload = ko.observable(null);
        self.disabled = ko.observable();
        self.readonly = ko.observable();
        self.dataIninTest = ko.observable();

        self.fileName = self.computed(function () {
            return fileToUpload() && fileToUpload().name;
        });

        // If specified during configure(), will be called with file contents when file is changed
        var callback = null;

        self.fileSelectionChanged = function (file) {
            if (file && !_.isUndefined(file[0])) {
                file = file[0];
                fileToUpload(file);

                fileReaderUtils.readFileContents(fileToUpload())
                    .then(function (res) {
                        if(callback) {
                            callback(res.fileContents);
                        }
                    })
                    .catch(function (err) {
                        errorCallbackFactory.createCallback({ namespace: "fileSelector.fileReadError" })(err);
                    });
            }
        };

        self.configure = function(options) {
            if(_.hasValue(options.callback)) {
                callback = options.callback;
            }
            else {
                LOG.warning('FileSelector.js - improper configuration');
            }
        };

        self.setDisabled = function(isDisabled) {
            self.disabled(isDisabled);
            self.readonly(!isDisabled);
        };

        self.setDisabled(false);
    });

    return FileSelector;
});

